import { render, staticRenderFns } from "./PeopleSportFilter.vue?vue&type=template&id=5bdac25a"
import script from "./peopleSportFilter.js?vue&type=script&lang=js&external"
export * from "./peopleSportFilter.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports